import { useLocalStorage } from '@vueuse/core'

import type { Customer } from '@brighterly/lib-core-types/customer/interfaces'
import type { KidStore } from '@stores/kid/interfaces'

import { isFullArray } from '@helpers/array'

import { hasActiveKid } from './getters'

const STORAGE_KEY = 'active_kid_id'

const persist = (state: KidStore): void => {
  const ls = useLocalStorage<number | null>(STORAGE_KEY, null)
  ls.value = state.activeKidId !== null ? Number(state.activeKidId) : null
}

const setActiveKid = (state: KidStore, id: number): void => {
  state.activeKidId = id
  persist(state)
}

const clear = (state: KidStore): void => {
  state.activeKidId = null
  persist(state)
}

export const actions = {
  hydrateFromStorage (this: KidStore): void {
    if (this._hydrated) return

    const ls = useLocalStorage<number | null>(STORAGE_KEY, null)

    this.activeKidId = ls.value !== null ? Number(ls.value) : null
    this._hydrated = true
  },
  persist (this: KidStore): void {
    return persist(this)
  },
  setActiveKid (this: KidStore, id: number): void {
    return setActiveKid(this, id)
  },
  clear (this: KidStore): void {
    return clear(this)
  },
  initFromCustomer (this: KidStore, customer: Customer | null): void {
    if (hasActiveKid(this)) return

    const firstKidId = customer?.kids?.[0]?.id || null

    if (firstKidId) {
      this.activeKidId = firstKidId
      persist(this)
    }
  },
  async reconcileWithCustomer (this: KidStore, customer: Customer | null): Promise<void> {
    const kids = customer?.kids ?? []

    if (!isFullArray(kids)) {
      clear(this)
      return
    }

    if (!hasActiveKid(this)) {
      await setActiveKid(this, kids[0]!.id)
      return
    }

    const exists = kids.some(kid => kid.id === this.activeKidId)

    if (!exists) {
      await setActiveKid(this, kids[0]!.id)
    }
  },
  setActiveKidDisciplines (this: KidStore, payload: KidStore['activeKidDisciplines']): void {
    this.activeKidDisciplines = payload
  },
  setActiveKidDisciplinesClear (this: KidStore): void {
    this.activeKidDisciplines = []
  },
}
